import { Form } from 'react-bootstrap'
import ModalCustom from '../../UI/modal'
import ChangeImage from '../../UI/change-image'
import Button from '../../UI/button'
import { IdType } from '../../types/card'

type Props = {
	show: boolean
	handleClose: () => void
	id?: IdType | null
}

const EditTripModal = ({show, handleClose, id}: Props) => {
  return (
	<ModalCustom show={show} onHide={handleClose} title='Edit Trip Information'>
		<Form>
			<Form.Group className='mb-3'>
				<Form.Label>Title</Form.Label>
				<Form.Control required type='text' placeholder='Enter here' />
			</Form.Group>
			<Form.Group className='mb-3'>
				<Form.Label>Description</Form.Label>
				<Form.Control height={84} as='textarea' cols={3} placeholder='Enter here' />
			</Form.Group>
			<ChangeImage style={{marginBottom: '24px'}} required={true} />
			<Button variant='primary' className='mx-auto' size='md' width={153}>Update</Button>
		</Form>
	</ModalCustom>
  )
}
export default EditTripModal